import { BaseResource } from "./BaseResource";
import { legacyApiResourceUrl, deeplyApplyKeyTransform } from "@ploy-lib/core";
import camelCase from "lodash/camelCase";
class ExternalViewSettingsResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.view = "";
        this.component = "";
        this.dtResult = {};
        this.endpoint = "";
        this.internalUser = false;
        this.token = "";
    }
    pk() {
        return this.view;
    }
    static detail() {
        return super.detail().extend({
            schema: this,
            method: "POST"
        });
    }
    static async fetch(input, init) {
        // perform actual network request getting back json
        const jsonResponse = await super.fetch(input, init);
        const data = deeplyApplyKeyTransform(jsonResponse, camelCase);
        if (data.endpoint && data.FetchBeforeLoadingComponent) {
            await fetch(data.endpoint, {
                credentials: "same-origin",
                headers: {
                    authorization: data.token
                }
            });
        }
        // do the conversion!
        return data;
    }
}
ExternalViewSettingsResource.urlRoot = legacyApiResourceUrl("ExternalView/LoadJson");
export { ExternalViewSettingsResource };
//# sourceMappingURL=ExternalViewSettingsResource.js.map